<template>
  <div class="rounded border-[1px] border-[#E0E0E0] p-[18px] mx-[18px]">
    <div class="flex flex-wrap gap-[8px] items-center mb-[16px]">
      <b-avatar
        :src="submissionDetail.warehouse_logo_url"
        :alt="submissionDetail.warehouse_name"
      />
      <div>
        <h3
          class="text-[14px] text-black font-semibold w-full sm:w-auto mb-0"
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[180px]': isOnLoading }"
        >
          {{ isOnLoading ? '' :submissionDetail.warehouse_name }}
        </h3>
        <p
          class="text-sm text-gray-500 mb-0"
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[16px] mt-[2px] !w-[150px]': isOnLoading }"
        >
          {{ isOnLoading ? '' :submissionDetail.warehouse_city }}
        </p>
      </div>
    </div>
    <div class="[&>div]:flex [&>div]:flex-wrap sm:[&>div]:flex-nowrap [&>div]:gap-[8px] [&>div]:items-start [&>div]:mb-[4px] text-black [&_p]:mb-0">
      <div>
        <p class="w-[150px] shrink-0">
          Detail Alamat
        </p>
        <p
          class="flex items-start gap-[4px] min-w-0"
        ><span>:</span> <span
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[200px]': isOnLoading }"
        >{{ isOnLoading ? '' : submissionDetail.detail_address }}</span></p>
      </div>
      <div class="!items-center">
        <p class="w-[150px]">
          Status Pengajuan
        </p>
        <p
          class="flex items-center gap-[4px]"
        >
          <span>:</span> <span
            :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[190px]': isOnLoading }"
          ><StorageRequestStatusCell
            v-if="!isOnLoading"
            :status="submissionDetail.submission_status"
          /></span>
        </p>
      </div>
      <div>
        <p
          class="w-[150px]"
        >
          Jumlah Produk
        </p>
        <p
          class="flex items-center gap-[4px]"
        ><span>:</span> <span
          :class="{ 'animate-pulse bg-[#E0E0E0] rounded-[4px] h-[20px] !w-[100px]': isOnLoading }"
        >{{ isOnLoading ? '' :submissionDetail.product_total }}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import StorageRequestStatusCell from './StorageRequestStatusCell.vue'

export default {
  name: 'WarehouseProfile',
  components: {
    StorageRequestStatusCell,
  },
  props: {
    isOnLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    submissionDetail: {
      type: Object,
      required: false,
      default: () => ({
        partner_logo_url: '',
        partner_owner: '',
        partner_city: '',
        partner_email: '',
        submission_status: '',
        product_total: '',
      }),
    },
  },
}
</script>
